<template>
  <div v-if="loaded" class="page">
    <b-navbar toggleable="lg" type="dark" variant="dark">
      <b-navbar-brand href="/">
        <div class="frontsvg">
          <component-logo imageWidth="40px" imageHeight="40px"></component-logo>
        </div>
      </b-navbar-brand>
      <b-navbar-brand class="headertext">Kompetenskollen</b-navbar-brand>
    </b-navbar>
    <div class="container">
      <div class="row">
        <div class="col-12">
          <div class="rubrikdesk">
            <h1>RESULTAT</h1>
          </div>
          <div class="resultattext">
            <h2>
              Du är igenom!
              <br>Här kan du se hur du matchade SOIs kompetensprofil.
            </h2>
          </div>
        </div>
        <div class="col col-lg-6" v-if="loadedTab === 'overview' || loadAllTabs === true">
          <div class="row">
            <div class="col-12">
              <div class="rubrikdeskovwerview">
                <h1>ÖVERSIKT</h1>
              </div>
              <div class="resultattextoverview">
                <h2>Du är igenom! Här får du en översikt på samtliga områden.</h2>
              </div>
              <chart-horizontalbar :chartData="bardata" @chartClicked="onChartClicked"></chart-horizontalbar>
            </div>
            <div class="col-12 d-lg-none">
              <div class="buttons">
                <div class>
                  <a href="/" target="_blank">
                    <button class="button3">Ta testet igen</button>
                  </a>
                </div>
              </div>
            </div>
            <div class="col-12 d-none d-lg-block">
              <div class="row">
                <div class="col-6">
                  <a href="SOI_Rapport_FramtidensOffentligaInkopare_Digital.pdf" target="_blank">
                    <button class="button3" style="line-height:1.1">Ladda ner SOIs kompetensprofil</button>
                  </a>
                </div>
                <div class="col-6">
                  <button class="button3" v-b-modal.showResult>Skicka mig resultatet!</button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col col-lg-6" v-if="loadedTab === 'result' || loadAllTabs === true">
          <div class="row">
            <div class="col-12">
              <div class="rubrikdeskresult">
                <h1>RESULTAT</h1>
              </div>
              <div class="resultattextresult">
                <h2>Du är igenom! Här kan du se hur du matchade SOIs kompetensprofil.</h2>
              </div>
              <chart-radar class="col d-lg-none" :chartData="radardata" :options="radardatamobile"></chart-radar>
              <chart-radar
                class="col d-none d-lg-block"
                style="margin-top: -69px"
                :chartData="radardata"
              ></chart-radar>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <div class="styrkor">
                <h2>Styrkor</h2>
              </div>
            </div>
            <div class="col-4" v-for="data in topResult" :key="data.id">
              <div class="center">{{data.labels[0]}}</div>
              <chart-doughnut :chartData="data"></chart-doughnut>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <div class="forbattring">
                <h2>Förbättringsmöjligheter</h2>
              </div>
            </div>
            <div class="col-4" v-for="data in bottomResult" :key="data.id">
              <div class="center">{{data.labels[0]}}</div>
              <chart-doughnut :chartData="data"></chart-doughnut>
            </div>
          </div>
          <div class="knapp1">
            <div class="row">
              <div class="col-12 d-lg-none">
                <a href="SOI_Rapport_FramtidensOffentligaInkopare_Digital.pdf" target="_blank">
                  <button class="button2" style="line-height:1.1">Ladda ner SOIs kompetensprofil</button>
                </a>
              </div>
            </div>
            <div class="knapp2">
              <div class="col-12">
                <a href="/">
                  <button class="button2">Ta testet igen</button>
                </a>
              </div>
              <div class="col-12" style="margin-top: 10px;">
                <a href="http://www.soi.se" target="_blank">
                  <button class="button2">Till soi.se</button>
                </a>
              </div>
            </div>
          </div>
        </div>
        <div class="col d-lg-none d-xl-none" v-if="loadedTab === 'shareresult' || loadAllTabs === true">
          <component-email :apiUrl="apiUrl" :resultId="savedResultId"></component-email>
        </div>
      </div>
    </div>
    <div class="bottombutton d-lg-none">
      <div class="row">
        <div class="col" style="background-color:#ec965b; border-left-style: solid; border-color: #f0ece6; padding-right:0; padding-left:0;">
          <button :class="{ activebutton: loadedTab === 'result' }" class="button" ontouchstart="" style="-webkit-tap-highlight-color: #f0ece6;" @click="loadedTab = 'result'">Resultat</button>
        </div>
        <div class="col" style="background-color:#ec965b; border-left-style: solid; border-color: #f0ece6; padding-left:0; padding-right:0;">
          <button :class="{ activebutton: loadedTab === 'overview' }" class="button" ontouchstart="" style="-webkit-tap-highlight-color: #f0ece6;" @click="loadedTab = 'overview'">Översikt</button>
        </div>
        <div class="col" style="background-color:red; padding-left:0; border-left-style: solid; border-color: #f0ece6;">
          <button :class="{ activebutton: loadedTab === 'shareresult' }" class="button" ontouchstart="" style="-webkit-tap-highlight-color: #f0ece6;" @click="loadedTab = 'shareresult'">Dela resultat</button>
        </div>
      </div>
    </div>
    <b-modal id="showResult" centered title hide-footer>
      <component-email :apiUrl="apiUrl" :resultId="savedResultId"></component-email>
    </b-modal>
    <b-modal v-model="barInfo.show" centered title hide-footer>{{barInfo.text}}</b-modal>
  </div>
</template>
<script>
import HorizontalBar from "./chart/HorizontalBar";
import Radar from "./chart/Radar";
import Doughnut from "./chart/Doughnut";
import Email from "./Email";
import Logo from "./Logo";
import axios from "axios";

export default {
  components: {
    "chart-horizontalbar": HorizontalBar,
    "chart-radar": Radar,
    "chart-doughnut": Doughnut,
    "component-email": Email,
    "component-logo": Logo
  },
  data () {
    return {
      apiUrl: "",
      barInfo: {
        show: false,
        text: ""
      },
      loaded: false,
      popupResult: false,
      loadAllTabs: false,
      loadedTab: "result",
      savedResultId: 0,
      sortedData: [],
      data: [],
      topResult: [],
      bottomResult: [],
      radardata: {
        labels: [],
        datasets: [
          {
            data: [],
            backgroundColor: ["rgba(236, 150, 91, 0.2)"],
            borderColor: ["rgba(236, 150, 91, 0.6)"],
            borderWidth: 2,
            pointRadius: 0
          }
        ]
      },
      radardatamobile: {
        tooltips: {
          enabled: false
        },
        hover: {
          mode: null
        },
        legend: {
          display: false
        },
        responsive: true,
        scale: {
          gridLines: {
            display: false
          },
          pointLabels: {
            fontSize: 10,
            fontStyle: 300,
            fontColor: "#2c302e",
            fontFamily: "museo-slab"
          },
          ticks: {
            beginAtZero: true,
            max: 100,
            display: false
          }
        }
      },
      bardata: {
        labels: [],
        datasets: [
          {
            data: [],
            backgroundColor: "rgba(236, 150, 91, 0.4)"
          },
          {
            data: [],
            backgroundColor: "rgba(225, 218, 207, 0.3)"
          }
        ]
      }
    };
  },
  methods: {
    onChartClicked (id) {
      this.barInfo.text = this.sortedData[id].entry;
      this.barInfo.show = true;
    },
    createBarResult () {
      // Since Bar doesnt have its own sorting we need to sort the data thats why this chart has its own method
      this.createData();

      // Create shallow copy to sort
      this.sortedData = this.data.slice();

      this.sortedData = this.sortedData.sort((a, b) => {
        return b.totalValue - a.totalValue;
      });

      // Update labels with the sorted labels
      this.bardata.labels = this.sortedData.map(data => {
        return data.title;
      });

      this.bardata.datasets[0].label = this.sortedData.map(data => {
        return data.entry;
      });

      // Update dataset with the sorted total values
      this.bardata.datasets[0].data = this.sortedData.map(data => {
        return data.totalValue;
      });
      // Create the stacked bar
      this.bardata.datasets[1].data = this.sortedData.map(data => {
        return 100 - data.totalValue;
      });
    },
    createRadarResult () {
      this.createData();

      // Update labels with the sorted labels
      this.radardata.labels = this.data.map(data => {
        return data.title;
      });

      // Update dataset with total values
      this.radardata.datasets[0].data = this.data.map(data => {
        return data.totalValue;
      });
    },
    createMinMaxResult (arr, desc) {
      this.createData();

      // Create shallow copy of data to be sorted
      var sortedData = this.data.slice();

      // Sort data in descending or ascending order
      sortedData = sortedData.sort((a, b) => {
        if (desc) {
          return b.totalValue - a.totalValue;
        } else {
          return a.totalValue - b.totalValue;
        }
      });

      // Take top 3 result and push them
      for (var i = 0; i < 3; i++) {
        arr.push({
          labels: [sortedData[i].title],
          datasets: [
            {
              data: [sortedData[i].totalValue, 100 - sortedData[i].totalValue],
              backgroundColor: [
                "rgba(236, 150, 91, 1)",
                "rgba(225, 218, 207, 1)"
              ],
              borderColor: ["rgba(236, 150, 91, 1)", "rgba(225, 218, 207, 1)"]
            }
          ]
        });
      }
    },
    createData () {
      this.loaded = true;

      // When there is an result route id show the saved result
      if (!this.$route.params.id) {
        var store = this.$store.state;
        this.data = store.sections.map(section => {
          var totalValue = 0;
          section.questions.forEach(question => {
            var answer =
              store.answers[section.id] &&
              store.answers[section.id][question.id]
                ? store.answers[section.id][question.id].answer
                : 0;
            totalValue = totalValue + answer;
          });

          return {
            id: section.id,
            entry: section.resultentry,
            title: section.shorttitle,
            totalValue: totalValue
          };
        });
      }
    },
    create () {
      this.createRadarResult();
      this.createBarResult();
      this.createMinMaxResult(this.topResult, true);
      this.createMinMaxResult(this.bottomResult);
    },
    handleResize (event) {
      if (window.innerWidth >= 992) {
        this.loadAllTabs = true;
      } else {
        this.loadAllTabs = false;
      }
    }
  },
  watch: {
    $route: "routeUpdated"
  },
  created () {
    if (window.innerWidth >= 992) {
      this.loadAllTabs = true;
    }

    window.addEventListener("resize", this.handleResize);
    this.apiUrl = process.env.VUE_APP_API_PATH;
    // If there is an route fetch the result form the api
    if (this.$route.params.id) {
      this.savedResultId = this.$route.params.id;
      // Fetch data
      axios(this.apiUrl + "Userdata/" + this.$route.params.id, {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        },
        method: "GET"
      })
        .then(result =>
          result.data
        )
        .then(result => {
          this.data = JSON.parse(result);
          this.create();
        });
    } else {
      this.create();
      // Spara datat till databasen
      var self = this;
      axios(this.apiUrl + "Userdata/", {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        data: JSON.stringify({
          data: JSON.stringify(this.data)
        })
      })
        .then(result => {
          return result.data;
        })
        .then((result) => {
          console.log("Guid: ", result);
          localStorage.clear();
          self.savedResultId = result;
        });
    }
  }
};
</script>

<style>

canvas#horizontalbar-chart{
  cursor: pointer;
}

</style>

<style scoped lang="scss">
h1 {
  font-family: "museo-slab";
  font-size: 24px;
  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: 1.5px;
  text-align: center;
  color: #2c302e;
  margin-top: 18px;
}
h2 {
  font-family: "museo-slab";
  font-size: 28px;
  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.5;
  letter-spacing: normal;
  color: #2c302e;
  text-align: center;
  margin-bottom: 41px;
  @media (max-width: 991px) {
    font-size: 18px;
  }
}
h3 {
  margin: 10px 0px 10px 20px;
  font-family: "museo-sans";
  font-size: 16px;
  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.5;
  letter-spacing: normal;
  color: #2c302e;
}
.center {
  text-align: center;
  font-size: 16px;
  position: absolute;
  left: 0%;
  top: 40%;
  height: 100%;
  width: inherit;
  text-align: center;
  @media (max-width: 991px) {
    font-size: 14px;
    position: absolute;
    left: 0%;
    top: 40%;
    height: 100%;
    width: inherit;
    text-align: center;
    @media (max-width: 561px) {
      font-size: 10px;
      position: absolute;
      left: 0%;
      top: 40%;
      height: 100%;
      width: inherit;
      text-align: center;
    }
  }
}
.forbattring {
  margin-top: 48px;
  h2 {
    margin-bottom: 24px;
  }
}
.styrkor {
  h2 {
    margin-bottom: 24px;
  }
}
.oversikt {
  margin: 0px 0px 0px 0px;
}
.headertext {
  text-align: center;
  width: 100%;
  margin: 0px;
}
.resultattextoverview {
  display: none;
  @media (max-width: 991px) {
    display: block;
    h2 {
      font-size: 16px;
      margin: 10px 10px 10px 10px;
      text-align: left;
    }
  }
}
.resultattextresult {
  display: none;
  @media (max-width: 991px) {
    display: block;
    h2 {
      font-size: 16px;
      margin: 10px 10px 10px 10px;
      text-align: left;
    }
  }
}
.resultattext {
  h2 {
    text-align: left;
    font-size: 24px;
  }
  @media (max-width: 991px) {
    display: none;
  }
}
@media (max-width: 992px) {
  .frontsvg {
    display: none !important;
  }
}
.page {
  background-color: #f0ece6;
  width: 100%;
  height: 100%;
  position: absolute;
  overflow: scroll;
  overflow-x: hidden;
  @media (min-width: 991px) {
    border: 20px solid white;
    overflow-y: auto;
  }
}
.button {
  background-color: #ec965b;
  border: none;
  width: 100%;
  height: 55px;
  border-radius: 0;
  outline: none;
  color: #fff;
  &:active {
    background-color: #f0ece6;
    color: black;
  }
  &:focus {
    background-color: #f0ece6;
    color: black;
  }
  &:hover{
    background-color: #f0ece6;
    color: black;
  }
  &:target{
    background-color: #f0ece6;
    color: black;
  }
}
.activebutton {
  background-color: #f0ece6;
  color: black;
}

.button2 {
  background-color: #22547f;
  border: none;
  height: 48px;
  width: 265px;
  margin: 0 auto;
  text-align: center;
  border-radius: 0;
  outline: none;
  color: #fff;
  font-family: "museo-sans";
  font-size: 16px;
}

.button3 {
  background-color: #22547f;
  border: none;
  height: 48px;
  width: 100%;
  margin: 0 auto;
  text-align: center;
  border-radius: 0;
  outline: none;
  color: #fff;
  margin-top: 20px;
  font-family: "museo-sans";
  font-size: 16px;
}

@media (max-width: 991px) {
  .buttons {
    text-align: center;
    margin-bottom: 100px;
  }
  .button3 {
    width: 265px;
  }
}

.bottombutton {
  position: fixed;
  bottom: 0;
  z-index: 4;
  width: 100%;
}
.knapp1 {
  text-align: center;
  margin-bottom: 100px;
  margin-top: 50px;
}
.knapp2 {
  margin-top: 10px;
}

.knapp2 .knapp2-link {
  margin-top: 5px;
}
.knapp3 {
  margin-top: 15px;
  margin-bottom: 50px;
}
.rubrikdeskovwerview {
  display: none;
  margin-top: 38px;
  margin-bottom: 19px;
  @media (max-width: 991px) {
    display: block;
    h1 {
      font-size: 24px;
      text-align: center;
    }
  }
}
.rubrikdeskresult {
  display: none;
  margin-top: 38px;
  margin-bottom: 19px;
  @media (max-width: 991px) {
    display: block;
    h1 {
      font-size: 24px;
      text-align: center;
    }
  }
}
.rubrikdesk {
  margin-top: 40px;
  margin-bottom: 50px;
  h1 {
    font-size: 48px;
    text-align: left;
  }
  @media (max-width: 991px) {
    display: none;
  }
}
</style>
<style>
.modal-content {
  background-color: #f0ece6 !important;
  margin: 0 auto;
  border: 10px solid #fff !important;
  width: 480px !important;
  border-radius: 0 !important;
  outline: none;
}

.modal-header {
  border-bottom: none !important;
}

.modal-header .close {
  position: absolute;
  top: 0;
  right: 0;
  margin: 0px 5px 0px 5px !important;
  padding: 0 !important;
  outline: none;
}
.vue-slider-mark-label {
  width: 60.5px;
  height: 28px;
  font-family: "museo-sans";
  font-size: 12px;
  font-weight: 300;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #43474b;
}
.modal-body {
  padding: 2rem!important;
}
@media (max-width:991px){
  .modal-body{
    padding: 1rem!important;
  }
}
</style>
